import React, { createContext, useCallback, useContext, useState } from "react";

const ConfirmationContext = createContext(null);

export function ConfirmationProvider({ children }) {
  const [confirmation, setConfirmation] = useState(null);

  const showConfirmation = useCallback(
    (title, message, onConfirm, onCancel) => {
      setConfirmation({
        id: Date.now(),
        title,
        message,
        onConfirm,
        onCancel,
      });
    },
    []
  );

  const handleConfirm = () => {
    if (confirmation?.onConfirm) {
      confirmation.onConfirm();
    }
    setConfirmation(null);
  };

  const handleCancel = () => {
    if (confirmation?.onCancel) {
      confirmation.onCancel();
    }
    setConfirmation(null);
  };

  return (
    <ConfirmationContext.Provider value={showConfirmation}>
      {children}
      {confirmation && (
        <div className="confirmation-overlay">
          <div className="confirmation-dialog">
            <div className="confirmation-header">
              <h2>{confirmation.title}</h2>
            </div>
            <div className="confirmation-body">
              <p>{confirmation.message}</p>
            </div>
            <div className="confirmation-footer">
              <button
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleConfirm}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmationContext.Provider>
  );
}

export function useConfirmation() {
  const ctx = useContext(ConfirmationContext);
  if (!ctx) {
    throw new Error(
      "useConfirmation must be used inside <ConfirmationProvider>"
    );
  }
  return ctx;
}
